import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    articles = [
        {
            thumbnail: 'assets/articles/autonavigator_2018_12_14.jpeg',
            category: 'Autónavigátor',
            title: 'Mit tudnak a prémium autóvédelmi rendszerek? Megnéztük!',
            subtitle: 'Távfelügyelet, mechanikai védelem, nyitás zsebből, applikációval vagy távirányítóval, blokkolás, menetnapló - mi mindent kapunk az egyes prémium autóvédelmi rendszerektől?',
            date: '2018-12-14',
            link: 'https://www.autonavigator.hu/cikkek/mit-tudnak-a-premium-autovedelmi-rendszerek-megneztuk/'
        },
        {
            thumbnail: 'assets/articles/speedzone_2020_09_22.jpeg',
            category: 'Speedzone',
            title: 'Speedzone használt: Lexus RC-F (2015): Csendes háttérember?',
            subtitle: 'Mi is lenne méltóbb egy Lexus védelmére, mint Gorilla S10? 13:45-től meghallgathatják, mit gondol Vályi Pista a Gorilla S10 Gépjárművédelmi rendszerről.',
            date: '2020-09-22',
            link: 'https://www.youtube.com/watch?v=1VHUPo9sZMw&t=825'
        },
        {
            thumbnail: 'assets/articles/speedzone_2020_05_19.jpeg',
            category: 'Speedzone',
            title: 'Speedzone-használt teszt: Audi R8 V10 (2017) Még mindig tudja',
            subtitle: 'Igen, ezt a gyönyörű Audi R8-at is Gorilla védi, nem véletlenül. A videóban 21:30-tól van szó a Gorilla S10 autóvédelmi rendszerről.',
            date: '2020-05-19',
            link: 'https://www.youtube.com/watch?v=pJMoLXWc7XM&t=1290s'
        },

        {
            thumbnail: 'assets/articles/autonavigator_2019_11_13.jpeg',
            category: 'Autónavigátor',
            title: 'Egy autóvédelmi rendszer, és ami mögötte van: Gorilla S10',
            subtitle: 'Egy profi autóvédelmi rendszerrel nem csupán egy terméket, hanem szolgáltatást is vásárolunk, így nem mindegy, hogy kik, miként csinálják.',
            date: '2019-11-13',
            link: 'https://www.autonavigator.hu/cikkek/egy-autovedelmi-rendszer-es-ami-mogotte-van-gorilla-s10/'
        },
        {
            thumbnail: 'assets/articles/bpiautosok_2019_09_06.jpeg',
            category: 'BP-i autósok közössége',
            title: 'Minden új autóban benne lenne a helye! Innovatív gépjárművédelmi rendszert teszteltünk.',
            subtitle: 'Megnéztük a szerintünk 2019-ben leginnovatívabb gépjárművédelmi rendszert és úgy döntöttünk, hogy megmutatjuk nektek.',
            date: '2019-09-06',
            link: 'https://www.youtube.com/watch?v=DafDeyBHhDA'
        },
        {
            thumbnail: 'assets/articles/autonavigator_2019_03_14.jpeg',
            category: 'Autónavigátor',
            title: 'Kipróbáltuk a legígéretesebb autóvédelmi rendszert',
            subtitle: 'Hiába van casco biztosításunk, ha ellopják autónkat, biztosan rosszul fogunk járni, ezért aztán érdemes védekezni ellene. Megnéztük a leginkább ígéretes hazai szolgáltatást.',
            date: '2019-03-14',
            link: 'https://www.autonavigator.hu/cikkek/kiprobaltuk-a-legigeretesebb-autovedelmi-rendszert/'
        },
        {
            thumbnail: 'assets/articles/gorillariaszto_2018_04_25.jpeg',
            category: 'Gorillariasztó',
            title: 'Gorilla S10 autóriasztó bemutatása',
            subtitle: 'A videóban Móró Balázs gépjármű védelmi szakértő mutatja be az utólag beszerelhető Gorilla S10 autóriasztó előnyeit a gyári riasztókkal szemben.',
            date: '2018-04-25',
            link: 'https://www.youtube.com/watch?v=2tAIgLax7tE'
        }
    ];

    constructor() {}

    getBackground(url) {
        return `url('${url}') no-repeat 50% 50%`;
    }

    articleList() {
        return this.articles.filter((c, i) => i > 0);
    }
}
